module.exports = __webpack_public_path__ + "static/media/icon-edit-order.b052a217.svg";